export interface User {
  id?: string;
  email: string;
  username?: string;
  roles?: string[];
  provider_id?: number | string;
  user_id?: number | string;
}

// Interfaz específica para la respuesta del login con JWT y permisos
export interface JwtLoginResponse {
  access: string;
  refresh: string;
  email: string;
  username: string;
  roles: string[];
  permissions: Permission[];
  user_id?: number;
  provider_id?: number;
  name?: string;
  role?: string;
}

// Obtener de perfil
export interface UserProfile {
  user_name: string;
  provider_name: string;
  business_name: string;
  RUC: string;
  email: string;
  phone: string;
  address: string;
  city: string;
}

export interface ProfileChangeLog {
  id: number;
  field: string;
  old_value: string;
  new_value: string;
  timestamp: string;
}

// Edicion de perfil
export interface UpdateUserProfile {
  phone: string;
  address: string;
  city: string | null;
  country: string | null;
  comune: string | null;
}

// Obtener de perfil
export interface UserProfile {
  user_name: string;
  provider_name: string;
  business_name: string;
  ruc: string;
  email: string;
  phone: string;
  address: string;
  city: string;
  country: string;
  comune: string;
}

export interface ProfileChangeLog {
  id: number;
  field: string;
  old_value: string;
  new_value: string;
  timestamp: string;
}

export interface LoginRequest {
  email: string;
  password: string;
}

export interface LoginResponse {
  token: string;
  user: User;
  refreshToken?: string;
}

export interface RegisterRequest {
  email: string;
  password: string;
  name?: string;
  [key: string]: unknown; // Para campos adicionales
}

export interface ResetPasswordRequest {
  token: string;
  password: string;
}

export interface ApiResponse<T = unknown> {
  success: boolean;
  message?: string;
  data?: T;
  errors?: string[] | Record<string, string[]>;
}

export interface AuthConfig {
  apiUrl: string;
  loginEndpoint: string;
  logoutEndpoint: string;
  registerEndpoint: string;
  profileEndpoint: string;
  forgotPasswordEndpoint: string;
  resetPasswordEndpoint: string;
  refreshTokenEndpoint: string;
  tokenRefreshInterval: number;
  tokenPrefix: string;
  storagePrefix: string;
  ownRoles: string;
  enableOwnRolesRequest?: boolean;
  postLoginRoute?: string;
}

export interface JwtAuthResponse {
  access: string;
  refresh: string;
  email: string;
  name?: string;
  role?: string;
  user_id?: string;
}

// State Ngrx
export interface AuthState {
  isAuthenticated: boolean;
  user: User | null;
  token: string | null;
  refreshToken: string | null;
  loading: boolean;
  error: string | null;
}

export const initialAuthState: AuthState = {
  isAuthenticated: false,
  user: null,
  token: null,
  refreshToken: null,
  loading: false,
  error: null,
};

export interface Permission {
  name: string;
  scopes: string[];
  display: 'on' | 'off';
}

export interface LoginResponse {
  access: string;
  refresh: string;
  email: string;
  username: string;
  roles: string[];
  permissions: Permission[];
}
